<template>
  <iframe id="resp-iframe" :src="src" style="width: 100%; height: 100vh; border: 0;" @load="iframeLoaded"></iframe>
</template>

<script>
export default {
  props: {
    src: {
      type: String,
      default: null
    },
    content: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    sendInformation (info) {
      info.preview = true;
      document.getElementById('resp-iframe').contentWindow.postMessage(info, '*');
      console.log('Send information', info);
    },
    async iframeLoaded () {
      this.sendInformation({ fields: this.content });
      this.$emit('iframe-loaded');
    }
  }
};
</script>
